export default (author, permlink) => (`https://ecency.com/post/@${author}/${permlink}`);


// WEBPACK FOOTER //
// ./src/utils/linkify.js